import '../scss/careers.scss';

import Swiper, { Pagination, A11y, Navigation } from 'swiper';


window.addEventListener('DOMContentLoaded', () => {
	const swiper = new Swiper('.swiper.reviews__grid', {
		speed: 400,
		centeredSlides: true,
		loop: true,
		// autoHeight: true,
		// calculateHeight: true,
		// adaptiveHeight: false,
		modules: [Pagination, A11y],
		breakpoints: {
			0: {
				slidesPerView: 1.2,
				spaceBetween: 0,
			},
			768: {
				slidesPerView: 2.2,
				spaceBetween: 0,
			}
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
	});

	const locationButtons = document.querySelectorAll('[data-location]');
	console.log('locationButtons', locationButtons)
	const jobListings = document.querySelectorAll('[data-joblocation]');
	console.log('jobListings', jobListings)

	if (locationButtons && jobListings) {
		locationButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				console.log('e.target.dataset.location', e.target.dataset.location)
				locationButtons.forEach((button) => {
					button.classList.remove('active');
				});
				e.target.classList.add('active');
				filterJobListings(e.target.dataset.location, jobListings);
			});
		});
	}
});

function filterJobListings(location, jobListings) {
	console.log('params', location, jobListings)
	jobListings.forEach((job) => {
		console.log('job', job.dataset.joblocation);
		if (job.dataset.joblocation === location) {
			show(job);
		} else if (location === 'all') {
			show(job);
			document.querySelectorAll('.job-list__job--empty').forEach((empty) => {
				hide(empty);
			});
		} else {
			hide(job);
		}
	});
}

function hide(element) {
	element.classList.add('out');
	window.setTimeout(() => {
		element.classList.remove('out');
		element.classList.add('hidden');
		element.setAttribute('aria-hidden', true);
	}, 450);
	window.clearTimeout();
}

function show(element) {
	element.classList.remove('hidden');
	element.setAttribute('aria-hidden', false);
	element.classList.add('in');
	window.setTimeout(() => {
		element.classList.remove('in');
	}, 450);
	window.clearTimeout();
}

